import React, { useEffect, useState } from "react";
import { back_icon, person2 } from "../../assets/img";
import { useNavigate, useLocation } from "react-router-dom";
import useStore from "../../Screen/redux/store/useStore";
// Firebase v9 imports
import { ref, onValue } from "firebase/database";
import { db } from "../../Services/firebase";
import useStoreKv from "../../Screen/redux/store/useStorekv";

const Header = () => {
  const { kv } = useStoreKv();
  const navigate = useNavigate();
  const location = useLocation();
  const totalWallet = kv.totalWallet ?? 0;
  // const [totalWallet, setTotalWallet] = useState(0);
  const { user } = useStore();
  const userId = user?.id;
  const pageTitles = {
    "/": "DASHBOARD",
    "/mobile-navbar": "Profile",
    "/admin": "Admin",
    "/admin-add": "Admin",
    "/role": "Roles Mapping",
    "/role-update": "Roles Mapping",
    "/client-list": "Client List",
    "/client-report": "Client Editor",
    "/blocked-client": "Blocked Client List",
    "/delete-data": "Delete Data",
    "/client-activity": "Client Activity",
    "/team-size": "Team Size",
    "/wallet-history": "Wallet History",
    "/admin-recharge": "Admin Recharge",
    "/recharge-history": "Recharge History",
    "/withdraw-history": "Withdraw History",
    "/announce-result-edit": "Announce Result",
    "/announce-result": "Announce Result",
    "/overall-result": "Overall Result",
    "/report": "Report",
    "/commission": "Commission History",
    "/announcement": "Announcement",
    "/holiday-update": "Holiday Update",
    "/help-support": "Help & Support",
    "/help-chat": "Help & Support",
    "/app-time": "APP TIME SETTING",
    "/winning-report": "Winning Report",
    "/purchase-report": "Purchase Report",
    "/sales": "Sales Report",
    "/cost-report": " Cost Report",
    "/add-link": "Add Links",
    "/lot-price": "Lot Price",
    "/draw-report": " Draw Report",
    "/cash-agency": " Winner Agency",
    "/number-wise": "Number Wise Report",
  };

  // useEffect(() => {
  //   const walletRef = ref(db, `admin/client/total_wallet`);

  //   const unsubscribe = onValue(walletRef, (snapshot) => {
  //     const data = snapshot.val();
  //     setTotalWallet(data?.total_amount ?? 0);
  //     //       console.log("Wallet amount updated from Firebase:", data ?? 0);
  //   });

  //   return () => unsubscribe();
  // }, [userId]);

  const handleNavigate = () => {
    navigate(-1); // Go back to previous page
  };
  const headerTitle =
    location.state?.title || pageTitles[location.pathname] || "DASHBOARD";

  return (
    <div className=" header-container ">
      <div className="d-flex ac-jb ">
        <img
          onClick={() => navigate(-1)}
          className="pointer"
          src={back_icon}
          height={18}
          width={18}
        />
        <p className="f4 fs-xs-20 fs-sm-20 fs-md-20 fs-lg-20 fs-xl-20 fs-xxl-20 primary2">
          {headerTitle}
        </p>
        <img
          src={person2}
          height={30}
          width={30}
          style={{
            cursor: "pointer",
          }}
          onClick={() => {
            //             console.log("profile-navigatuon");
            navigate("/mobile-navbar", { state: { fromFooter: true } });
          }}
        />
      </div>
      <div className="d-flex ac-jb my-3">
        <p className="f3 fs-xs-16 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-18 fs-xxl-18 primary2">
          {user?.name || ""}
        </p>
        <p className="f3 fs-xs-16 fs-sm-14 fs-md-16 fs-lg-18 fs-xl-18 fs-xxl-18 primary2">
          ₹ {totalWallet}
        </p>
      </div>
    </div>
  );
};

export default Header;
